import { render, staticRenderFns } from "./ChpcFooter.vue?vue&type=template&id=55452515&scoped=true&"
import script from "./ChpcFooter.vue?vue&type=script&lang=js&"
export * from "./ChpcFooter.vue?vue&type=script&lang=js&"
import style0 from "./ChpcFooter.vue?vue&type=style&index=0&id=55452515&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55452515",
  null
  
)

export default component.exports